import { gql } from '@apollo/client';
import SPECIFICATION_HEADER from '../fragments/SPECIFICATION_HEADER';

const GET_SPECIFICATION_FOLDER_CONTENTS_DATA = gql`
  ${SPECIFICATION_HEADER}
  fragment FolderTileData on ModelSpecificationFolderNode {
    id
    name
    modelSpecificationsCount
    foldersCount
    createdDate
    modifiedDate
    canBeRemoved
  }
  fragment FolderContentsData on ModelSpecificationFolderNode {
    id
    name
    modelSpecifications(search: $search, orderBy: $orderBy, isActive: true, state: $state) {
      edges {
        node {
          ...SpecificationHeaderFragment
        }
      }
    }
    folders(search: $search, orderBy: $orderBy, isActive: true) {
      edges {
        node {
          ...FolderTileData
        }
      }
    }
    parentFolder {
      id
    }
    canBeRemoved
    path {
      id
      name
    }
  }

  query getSpecificationFolderContentsData(
    $modelSpecificationFolderId: ID!
    $search: String
    $orderBy: String
    $state: [String]
  ) {
    node(id: $modelSpecificationFolderId) {
      ...FolderContentsData
    }
  }
`;

export default GET_SPECIFICATION_FOLDER_CONTENTS_DATA;
